import React from "react";
import { theme } from "../../../styles";
import { Modal } from "../../modal/modal";
import {
  BimbelModal,
  BimbelModalButtonContainer,
  BimbelModalStudentTitle,
  BimbelModalSubTitle,
  BimbelModalTitle
} from "./new-paid-user-bimbel-modal.styles";
import { Button } from "../../atoms/button/button";
import { IPrimaryUser } from "../../../services/api/auth/authService.types";
import { Animation } from "../../animation/animation";

const NewPaidUserFirstClassDoneModal = ({
  onClose,
  isOpen,
  primaryUser
}: {
  onClose: () => void;
  isOpen: boolean;
  primaryUser: IPrimaryUser;
}): JSX.Element => {
  const displayProperties = {
    backgroundColor: theme.colors.brand[600]
  };

  const closeIconProperties = {
    isHidden: true
  };

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      displayProperties={displayProperties}
      closeIconProperties={closeIconProperties}
      closeOnClickOutside={false}>
      <BimbelModalStudentTitle>
        Cooool, {primaryUser.full_name}
      </BimbelModalStudentTitle>
      <BimbelModalTitle>Makasih udah hadir di kelas pertamamu</BimbelModalTitle>
      <BimbelModalSubTitle>
        Jangan lupa hadir di kelas selanjutnya, ya.
      </BimbelModalSubTitle>
      <BimbelModalButtonContainer>
        <Button onClick={() => onClose()} variant={"secondary"}>
          Oke, sip
        </Button>
      </BimbelModalButtonContainer>
      <BimbelModal>
        <Animation
          loop={false}
          path="/assets/kelas-live/animation/bimbel-welcome-modal.json"
          updatedPath="/assets/kelas-live/animation/bimbel-welcome-modal-looping-movement.json"
        />
      </BimbelModal>
    </Modal>
  );
};

export { NewPaidUserFirstClassDoneModal };
